import axios from "axios";
import UserApiRoute from "./UserApiRoute";
import PartnerProfile from "./partner/PartnerProfile";
import SearchPartnerFilters from "./partner/SearchPartnerFilters";
import FindAllProfilesResponse from "./partner/FindAllProfilesResponse";
import { AccountTypeKey } from "./AccountType";
import ClientProfile from "./client/ClientProfile";
import Appointment from "../booking/Appointment";
import RegisterUserResponse from "./RegisterUserResponse";
import EditClientProfileRequestBody from "./client/EditClientProfileRequestBody";

export interface ErrorResponse {
  status: number;
  message: string;
}

export default class UserProfileApi {
  async findById(id: string) {
    const response = await axios.get<PartnerProfile>(
      `${UserApiRoute.PROFILE}/${id}`
    );
    return response.data;
  }

  async search(form: SearchPartnerFilters) {
    const response = await axios.post<FindAllProfilesResponse>(
      UserApiRoute.PROFILE_SEARCH,
      form
    );
    return response.data;
  }

  async getByUserId(
    userId: string,
    accountType: AccountTypeKey
  ): Promise<PartnerProfile | ClientProfile> {
    const response = await axios.get(
      `${UserApiRoute.PROFILE}/${accountType}/${userId}?userId=${userId}`,
      {
        withCredentials: true,
      }
    );
    return response.data;
  }

  async getClientProfileById(userId: string): Promise<ClientProfile> {
    const response = await axios.get(
      `${UserApiRoute.PROFILE}/client/${userId}?userId=${userId}`,
      {
        withCredentials: true,
      }
    );
    return response.data;
  }

  async getPublicByResourceId(id: string): Promise<PartnerProfile> {
    const response = await axios.get(`${UserApiRoute.PROFILE}/public/${id}`, {
      withCredentials: true,
    });
    return response.data;
  }

  async getFuturePartnerAppointments(
    partnerId: string
  ): Promise<Appointment[]> {
    const id = encodeURIComponent(partnerId);
    const response = await axios.get(
      `${UserApiRoute.PROFILE}/partner/appointment/all-future/${id}`,
      {
        withCredentials: true,
      }
    );
    return response.data;
  }

  async createClientProfile(
    userId: string,
    form: EditClientProfileRequestBody
  ): Promise<RegisterUserResponse> {
    const response = await axios.post(
      `${UserApiRoute.PROFILE}/client/${userId}?userId=${userId}`,
      form,
      {
        withCredentials: true,
      }
    );
    return response.data;
  }

  async updateClientProfile(
    userId: string,
    form: EditClientProfileRequestBody
  ): Promise<RegisterUserResponse> {
    const response = await axios.put(
      `${UserApiRoute.PROFILE}/client/${userId}?userId=${userId}`,
      form,
      {
        withCredentials: true,
      }
    );
    return response.data;
  }

  async deleteByUserId(userId: string) {
    return axios.delete(
      `${UserApiRoute.PROFILE}/partner/${userId}?userId=${userId}`,
      {
        withCredentials: true,
      }
    );
  }
}
